export default __webpack_public_path__ + "static/media/image.53d18c84.png";